<!-- The first-use hint on the wall. Gone for good after the first drag. -->
<template>
  <Transition :name="reducedMotion ? 'hint-fade' : 'hint'">
    <div v-if="show" class="shelf-hint" role="note">
      <span class="shelf-hint__glyph" aria-hidden="true">
        <IonIcon :icon="handLeftOutline" />
      </span>
      <span>Swipe along the wall · tap a bag to pick it up</span>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { IonIcon } from '@ionic/vue';
import { handLeftOutline } from 'ionicons/icons';
import { prefs } from '../core/storage.js';
import { reducedMotion } from '../store.js';

const props = defineProps({ ready: { type: Boolean, default: true } });

const learned = ref(!!prefs.shelfHintDone);
const show = ref(false);

onMounted(() => {
  if (learned.value) return;
  // After the wall has racked, so it does not compete with the loading state.
  const wait = () => { if (props.ready) setTimeout(() => { if (!learned.value) show.value = true; }, 700); else setTimeout(wait, 200); };
  wait();
});

/** Call on the first drag: hides the hint and remembers it. */
function dismiss () {
  if (learned.value) return;
  learned.value = true;
  show.value = false;
  prefs.shelfHintDone = true;
}

defineExpose({ dismiss });
</script>

<style scoped>
.shelf-hint {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-4) var(--sp-2) var(--sp-2);
  border-radius: 999em;
  background: var(--ink, #1F2A22);
  color: var(--dock, #FAF7F1);
  font-size: var(--text-sm);
  font-weight: 600;
  box-shadow: 0 10px 24px -10px rgba(40, 30, 20, 0.5);
  font-family: var(--font-body, 'Manrope', sans-serif);
  pointer-events: none;
  max-width: calc(100vw - 32px);
  white-space: nowrap;
  font-size: var(--text-sm);
  text-align: left;
}
.shelf-hint__glyph {
  flex: none;
  display: grid;
  place-items: center;
  width: calc(var(--sp-6) + var(--sp-1));
  height: calc(var(--sp-6) + var(--sp-1));
  border-radius: 50%;
  background: color-mix(in srgb, var(--dock, #FAF7F1) 14%, transparent);
  font-size: var(--text-lg);
}
.shelf-hint__glyph ion-icon { animation: nudge 2.4s var(--ease) 1s 2; }
@keyframes nudge {
  0%, 100% { transform: translateX(0); }
  30% { transform: translateX(calc(var(--sp-1) * -1.5)); }
  60% { transform: translateX(calc(var(--sp-1) * 1.5)); }
}
.hint-enter-active, .hint-leave-active { transition: opacity 300ms var(--ease), transform 300ms var(--ease); }
.hint-enter-from, .hint-leave-to { opacity: 0; transform: translateY(var(--sp-2)); }
.hint-fade-enter-active, .hint-fade-leave-active { transition: opacity 150ms linear; }
.hint-fade-enter-from, .hint-fade-leave-to { opacity: 0; }
@media (prefers-reduced-motion: reduce) {
  .shelf-hint__glyph ion-icon { animation: none; }
}
</style>
